export default {
  setPackageSchema(configSettings) {
    let origin = []
    configSettings.airport.forEach(airport => {
      origin.push({
        type: 'airport',
        value: airport
      })
    })
    let destination = configSettings.destinationToSearch.city
      ? [{ type: 'city', value: configSettings.destinationToSearch.city[0] }]
      : configSettings.destinationToSearch.region
      ? [
          {
            type: 'region',
            value: configSettings.destinationToSearch.region[0]
          }
        ]
      : [
          {
            type: 'regiongroup',
            value: configSettings.destinationToSearch.regiongroup[0]
          }
        ]

    return JSON.stringify({
      config: {
        action: 's',
        language: configSettings.language,
        country: configSettings.country,
        groupby: ['accommodationduration'],
        passenger: configSettings.passengers,
        upstream: {
          groupby: ['accommodation']
        },
        transfer: {
          required: false
        },
        railandfly: {
          required: false
        },
        rentalcar: {
          required: false
        },
        pagination: {
          offset: 0,
          count: configSettings.count
        },
        duration: {
          min: configSettings.durationMin,
          max: configSettings.durationMax
        },
        attribution: {
          product: configSettings.product,
          subcategory: 'bananas',
          pagetype: 'conversion',
          pageid: configSettings.pageid.toString(),
          usersession: 'none'
        }
      },
      filters: {
        price: {
          max: configSettings.maxPricePerPerson
        }
      },
      portions: [
        {
          origin: origin,
          dep: {
            start: configSettings.startDate,
            end: configSettings.endDate
          },
          destination: destination
        },
        {
          origin: destination,
          dep: {
            start: configSettings.startDate,
            end: configSettings.endDate
          },
          destination: origin
        }
      ],
      accommodation: {
        category: {
          min: configSettings.minHotelCategory
        },
        rating: {
          recommendation: {
            min: configSettings.minHotelRecommendation
          }
        },
        board: {
          min: configSettings.minBoardType
        }
      }
    })
  }
}
